import React, { useContext, useRef } from 'react';
import { useDeepCompareEffect } from 'use-deep-compare';
export const ConfigurationContext = React.createContext(undefined);
export default function useConfiguration() {
    const configuration = useContext(ConfigurationContext);
    if (!configuration) {
        throw new Error('Configuration not found, ensure that the configuration is fetched and parsed before this hooked is used.');
    }
    // Code to actually deep compare the configuration and avoid different instances from being returned with the same values
    const configurationRef = useRef(configuration);
    useDeepCompareEffect(() => {
        configurationRef.current = configuration;
    }, [configuration]);
    return configurationRef.current;
}
//# sourceMappingURL=UseConfiguration.js.map